/* Cybber Reviews — seção de avaliações (GUIA/Guia_Review(P2P).md, Fase 8).
   Sem dependência. Filtro por estrela / com foto / tamanho, "Show more reviews" (revela
   a página 1 e busca p02.. pela Storefront API), lightbox acessível (foco preso, Esc). */
(function () {
  'use strict';

  var FIT = { pequeno: 'Fit: runs small', certo: 'Fit: true to size', grande: 'Fit: runs large' };
  var STORE = (document.querySelector('.cyr[data-store]') || { dataset: {} }).dataset.store || 'the store';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function fmtDate(iso) {
    var p = String(iso || '').split('-');
    return p.length === 3 ? p[2] + ' ' + MONTHS[+p[1] - 1] + ' ' + p[0] : esc(iso);
  }
  function stars(rating) {
    return '<span class="cyr-stars cyr-stars--small" aria-hidden="true"><span class="cyr-stars__bg">★★★★★</span>' +
      '<span class="cyr-stars__fg" style="width:' + rating * 20 + '%">★★★★★</span></span>' +
      '<span class="visually-hidden">' + rating + ' out of 5</span>';
  }

  /* Mesma marcação de snippets/cybber-review-item.liquid. */
  function item(r) {
    var meta = [];
    if (r.variant) meta.push('<span>Variant: ' + esc(r.variant) + '</span>');
    else if (r.size) meta.push('<span>Size bought: ' + esc(r.size) + '</span>');
    if (FIT[r.fit]) meta.push('<span>' + FIT[r.fit] + '</span>');
    var photos = (r.photos || []).map(function (ph, i) {
      return '<button type="button" class="cyr__thumb cyr__thumb--small" data-cyr-open="' + esc(r.id) +
        '" data-cyr-photo="' + i + '" data-full="' + esc(ph.url) + '" aria-label="Open photo ' + (i + 1) + '">' +
        '<img src="' + esc(sized(ph.url, 160)) + '" alt="Customer photo" loading="lazy" width="80" height="80"></button>';
    }).join('');
    return '<article class="cyr-review" data-cyr-id="' + esc(r.id) + '" data-rating="' + r.rating +
      '" data-photos="' + (r.photos || []).length + '" data-size="' + esc(r.size || '') + '">' +
      '<header class="cyr-review__head">' + stars(r.rating) +
      '<span class="cyr-review__author">' + esc(r.author) + '</span>' +
      (r.verified ? '<span class="cyr-review__verified">Verified buyer</span>' : '') +
      (r.country ? '<span class="cyr-review__country">' + esc(r.country) + '</span>' : '') +
      '<time class="cyr-review__date" datetime="' + esc(r.date) + '">' + fmtDate(r.date) + '</time></header>' +
      (r.title ? '<h3 class="cyr-review__title">' + esc(r.title) + '</h3>' : '') +
      (r.body ? '<p class="cyr-review__body">' + esc(r.body).replace(/\n/g, '<br>') + '</p>' : '') +
      (meta.length ? '<p class="cyr-review__meta">' + meta.join('') + '</p>' : '') +
      (r.reply ? '<div class="cyr-review__reply"><strong>Response from ' + esc(STORE) + '</strong><p>' +
        esc(r.reply).replace(/\n/g, '<br>') + '</p></div>' : '') +
      (photos ? '<div class="cyr-review__photos">' + photos + '</div>' : '') +
      '</article>';
  }

  function fetchPage(root, n) {
    var key = 'p' + (n < 10 ? '0' + n : n);
    return fetch('/api/' + root.dataset.api + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': root.dataset.token },
      body: JSON.stringify({
        query: 'query($h:String!,$k:String!){product(handle:$h){metafield(namespace:"cybber_reviews",key:$k){value}}}',
        variables: { h: root.dataset.handle, k: key }
      })
    }).then(function (res) { return res.json(); }).then(function (data) {
      var mf = data && data.data && data.data.product && data.data.product.metafield;
      return mf ? JSON.parse(mf.value) : [];
    });
  }

  function init(root) {
    var list = root.querySelector('[data-cyr-list]');
    var more = root.querySelector('[data-cyr-more]');
    var status = root.querySelector('.cyr__status');
    var sizeSel = root.querySelector('[data-cyr-size]');
    var photosBtn = root.querySelector('[data-cyr-photos]');
    var initial = parseInt(root.dataset.initial, 10) || 10;
    var pages = parseInt(root.dataset.pages, 10) || 1;
    var nextPage = 2;
    var shown = initial;
    var filter = { star: 0, photos: false, size: '' };
    var loading = false;

    function articles() { return Array.prototype.slice.call(list.querySelectorAll('.cyr-review')); }
    function matches(a) {
      return (!filter.star || +a.dataset.rating === filter.star) &&
        (!filter.photos || +a.dataset.photos > 0) && (!filter.size || a.dataset.size === filter.size);
    }
    function canFetch() { return nextPage <= pages && root.dataset.token; }

    function fillSizes() {
      var seen = {};
      Array.prototype.forEach.call(sizeSel.options, function (o) { seen[o.value] = true; });
      articles().forEach(function (a) {
        var s = a.dataset.size;
        if (s && !seen[s]) { seen[s] = true; sizeSel.add(new Option(s, s)); }
      });
      sizeSel.parentNode.hidden = sizeSel.options.length <= 1;
    }

    function render() {
      var count = 0;
      articles().forEach(function (a) {
        var ok = matches(a);
        if (ok) count++;
        a.classList.toggle('cyr-review--hidden', !ok || count > shown);
      });
      more.hidden = !(count > shown || canFetch());
      status.textContent = (filter.star || filter.photos || filter.size) ? count + ' matching reviews loaded' : '';
    }

    function loadMore() {
      if (loading) return;
      var matching = articles().filter(matches).length;
      shown += initial;
      if (matching >= shown || !canFetch()) { render(); return; }
      loading = true;
      more.disabled = true;
      more.textContent = 'Loading…';
      fetchPage(root, nextPage).then(function (items) {
        nextPage++;
        list.insertAdjacentHTML('beforeend', items.map(item).join(''));
        fillSizes();
      }).catch(function () {
        nextPage = pages + 1; /* sem token válido ou rede: para de buscar */
      }).then(function () {
        loading = false;
        more.disabled = false;
        more.textContent = 'Show more reviews';
        render();
        if (articles().filter(matches).length < shown && canFetch()) loadMore();
      });
    }

    function setFilter(k, v) { filter[k] = v; shown = initial; render(); }

    root.querySelectorAll('[data-cyr-star]').forEach(function (b) {
      b.addEventListener('click', function () {
        var star = +b.dataset.cyrStar;
        var on = filter.star !== star;
        root.querySelectorAll('[data-cyr-star]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        setFilter('star', on ? star : 0);
      });
    });
    photosBtn.addEventListener('click', function () {
      var on = !filter.photos;
      photosBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      setFilter('photos', on);
    });
    sizeSel.addEventListener('change', function () { setFilter('size', sizeSel.value); });
    more.addEventListener('click', loadMore);

    /* ---- lightbox ---- */
    // :not(.cyr-form): o formulário (Fase 9) usa o mesmo visual e vem antes no HTML —
    // pegar o primeiro .cyr-lightbox quebrava aqui e o formulário nunca era ligado.
    var box = root.querySelector('.cyr-lightbox:not(.cyr-form)');
    var img = box.querySelector('.cyr-lightbox__img');
    var text = box.querySelector('.cyr-lightbox__text');
    var photos = [], pos = 0, opener = null;

    function show() {
      img.src = sized(photos[pos], 1200);
      box.querySelector('.cyr-lightbox__nav').hidden = photos.length < 2;
    }
    function open(btn) {
      var art = list.querySelector('[data-cyr-id="' + btn.dataset.cyrOpen + '"]');
      if (!art) return;
      photos = Array.prototype.map.call(art.querySelectorAll('[data-full]'), function (t) { return t.dataset.full; });
      if (!photos.length) return;
      pos = Math.min(+btn.dataset.cyrPhoto || 0, photos.length - 1);
      var body = art.querySelector('.cyr-review__body');
      var author = art.querySelector('.cyr-review__author');
      text.textContent = (author ? author.textContent + ': ' : '') + (body ? body.textContent.slice(0, 280) : '');
      opener = btn;
      box.hidden = false;
      document.documentElement.classList.add('cyr-noscroll');
      show();
      box.querySelector('[data-cyr-close]').focus();
    }
    function close() {
      box.hidden = true;
      document.documentElement.classList.remove('cyr-noscroll');
      if (opener) opener.focus();
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cyr-open]');
      if (t) open(t);
    });
    box.querySelector('[data-cyr-close]').addEventListener('click', close);
    box.querySelector('[data-cyr-prev]').addEventListener('click', function () { pos = (pos + photos.length - 1) % photos.length; show(); });
    box.querySelector('[data-cyr-next]').addEventListener('click', function () { pos = (pos + 1) % photos.length; show(); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowRight') box.querySelector('[data-cyr-next]').click();
      if (e.key === 'ArrowLeft') box.querySelector('[data-cyr-prev]').click();
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    fillSizes();
    render();
  }

  /* ---- formulário "Write a review" (Fase 9) ---- */
  function readToken(t) {
    try {
      var raw = t.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(raw + '==='.slice((raw.length + 3) % 4)));
    } catch (e) { return null; }
  }

  function initForm(root) {
    var box = root.querySelector('.cyr-form');
    if (!box) return;
    var form = box.querySelector('form');
    var msg = box.querySelector('.cyr-form__msg');
    var send = box.querySelector('.cyr-form__send');
    var captcha = box.querySelector('.cyr-form__captcha');
    var opener = null;
    var widgetReady = false;

    function loadTurnstile() {
      if (widgetReady) return;
      widgetReady = true;
      window.cyrTurnstileReady = function () {
        window.turnstile.render(captcha, { sitekey: box.dataset.sitekey });
      };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=cyrTurnstileReady&render=explicit';
      s.async = true;
      document.head.appendChild(s);
    }
    function open(btn) {
      opener = btn || null;
      box.hidden = false;
      document.documentElement.classList.add('cyr-noscroll');
      loadTurnstile();
      var first = box.querySelector('input[name="rating"]');
      if (first) first.focus();
    }
    function close() {
      box.hidden = true;
      document.documentElement.classList.remove('cyr-noscroll');
      if (opener) opener.focus();
    }
    root.querySelectorAll('[data-cyr-write]').forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    box.querySelector('[data-cyr-form-close]').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Link do e-mail de convite: ?cyr_token=… abre o formulário já com o e-mail.
    var token = new URLSearchParams(window.location.search).get('cyr_token');
    if (token) {
      var data = readToken(token);
      form.elements.token.value = token;
      if (data && data.e) { form.elements.email.value = data.e; form.elements.email.readOnly = true; }
      open(null);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.textContent = '';
      if (!form.querySelector('input[name="rating"]:checked')) { msg.textContent = 'Please choose a star rating.'; return; }
      if (!form.reportValidity()) return;
      var files = form.elements.photos.files;
      if (files.length > 5) { msg.textContent = 'Up to 5 photos, please.'; return; }
      for (var i = 0; i < files.length; i++) {
        if (files[i].size > 10 * 1024 * 1024) { msg.textContent = 'Each photo can be up to 10 MB.'; return; }
      }
      send.disabled = true;
      msg.textContent = 'Sending…';
      fetch(box.dataset.submit.replace(/\/+$/, '') + '/api/reviews/public/submit', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (d) {
          if (d && d.ok) {
            form.reset();
            form.hidden = true;
            msg.textContent = d.message || 'Thank you! Your review will appear after a quick check.';
            box.querySelector('.cyr-form__panel').appendChild(msg);
          } else {
            msg.textContent = (d && d.error) || 'Sorry, something went wrong. Please try again.';
            if (window.turnstile) window.turnstile.reset();
          }
        })
        .catch(function () { msg.textContent = 'Sorry, we could not send your review. Please try again.'; })
        .then(function () { send.disabled = false; });
    });
  }

  function boot() {
    document.querySelectorAll('.cyr[data-handle]').forEach(function (root) {
      if (root.querySelector('[data-cyr-list]')) init(root);
      initForm(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.CybberReviews = { item: item, esc: esc, sized: sized, fmtDate: fmtDate, readToken: readToken };
})();
